import {styled, css } from "@mui/material/styles";

export const Item = styled('li')<{ customColor?: boolean; disabled?: boolean }>`
  &&& {
    --backgroundColor: ${({customColor}) =>
            !customColor ? 'rgba(243, 231, 218, 255)' : 'rgba(61, 177, 87, 0.12)'};
    --backgroundColorDarker: ${({customColor}) =>
            !customColor ? 'rgba(243, 231, 218, 255)' : 'rgba(61, 177, 87, 0.25)'};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 6px 16px;
    cursor: pointer;

    h6 {
      font-weight: 400;
      color: #1D1D1D;
        font-family: "Acid Grotesk", sans-serif;
    }

    ${({disabled}) => disabled ?
        css`cursor: not-allowed;` :
        css`
          &:hover {
            background: var(--backgroundColor, rgba(61, 177, 87, 0.12)) !important;
          }
    
          &[aria-selected='true'] {
            background: var(--backgroundColorDarker,
            rgba(61, 177, 87, 0.25)) !important;
          }
    
          &.Mui-focused {
            background: var(--backgroundColor, rgba(61, 177, 87, 0.12)) !important;
          }
    
          &[aria-selected='true']:hover {
            background: var(--backgroundColorDarker,
            rgba(61, 177, 87, 0.25)) !important;
          }`
    }
  }
`;
